import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
import animations from "./animations.js";



function initScrollBasedAnimations() {

	// create the scrollSmoother before your scrollTriggers

	/*
		ScrollSmoother.create({
			smooth: 5,               // how long (in seconds) it takes to "catch up" to the native scroll position
			effects: true,           // looks for data-speed and data-lag attributes on elements
			// smoothTouch: 0.1,        // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
		  });
		  */


	const is_scrolltrigger = document.querySelector('.scrolltrigger-page');
	const scroll_down = document.getElementById('scroll-down');
	const box_composition_simple = document.querySelector('.box-composition-simple-flex');

	if( box_composition_simple ){

		gsap.to(box_composition_simple, {
			scrollTrigger: {
				trigger: box_composition_simple,
				start: "bottom bottom",
				end: "bottom top",
				scrub: true,
				onEnter: () => animations.smxBoxCompositionAnimation('enter'),
			},
		});

	}


	if (is_scrolltrigger) {

		// var time_to_show = false;

		var show = false;

		document.addEventListener("scroll", () => {
			scroll_down.classList.remove('visible');

			if (show) {
				clearTimeout(show);
			}

			show = setTimeout(function () {
				scroll_down.classList.add('visible');
			}, 10000)


		});


		gsap.to("#main-bkg-image", {
			scrollTrigger: {
				trigger: "#smx-step-title",
				start: "top center-=-20%",
				end: "center center",
				scrub: true,
			},
			opacity: 0,
		});

		gsap.to("#smx-product-image", {
			scrollTrigger: {
				trigger: "#smx-step-title",
				start: "top center-=-20%",
				end: "center center",
				scrub: true,
			},
			opacity: 0.5,
		});

		gsap.to("#smx-step-title", {
			scrollTrigger: {
				trigger: "#smx-step-title",
				start: "top center-=-20%",
				end: "center 40%",
				scrub: true,
			},
			opacity: 1,
		});

		gsap.to("#smx-product-title .title", {
			scrollTrigger: {
				trigger: "#smx-product-title .title",
				start: "top center-=-15%",
				end: "center 40%",
				scrub: true,
			},
			opacity: 1,
		});


		gsap.to("#smx-short-description p", {
			scrollTrigger: {
				trigger: "#smx-short-description",
				start: "top center-=-15%",
				end: "center 40%",
				scrub: true,
			},
			opacity: 1,
		})


		gsap.to("#smx-product-title .title", {
			scrollTrigger: {
				trigger: "#smx-product-title .title",
				start: "center 40%",
				end: "+=400",
				scrub: true,
			},
			backgroundPosition: "-200% 0",
		});


		gsap.to("#smx-product-image", {
			scrollTrigger: {
				trigger: "#smx-product-title .title",
				start: "center 40%",
				end: "+=400",
				scrub: true,
			},
			transform: "translate(-50%, -50%) scale(0.7)",
		});


		gsap.to('#smx-step-title h2', {
			scrollTrigger: {
				trigger: "#smx-description",
				start: "top 70%",
				end: "top 50%",
				scrub: true,
			},
			translateY: "-100px",
			opacity: 0,
		});

		gsap.to('#smx-product-title', {
			scrollTrigger: {
				trigger: "#smx-description",
				start: "top 70%",
				end: "top 50%",
				scrub: true,
			},
			translateY: "-100px",
			opacity: 0,
		});

		gsap.to('#smx-short-description', {
			scrollTrigger: {
				trigger: "#smx-description",
				start: "top 70%",
				end: "top 50%",
				scrub: true,
			},
			translateY: "-100px",
			opacity: 0,
		});

		gsap.to('#smx-description', {
			scrollTrigger: {
				trigger: "#smx-description",
				start: "top 70%",
				end: "top 50%",
				scrub: true,
			},

			opacity: 1,
		});

		/*
		gsap.to('#smx-page-menu', {
			scrollTrigger: {
				trigger: "#smx-description",
				start: "top 70%",
				end: "top 50%",
				scrub: true,
				onEnter: () => document.getElementById('smx-page-menu').classList.add('active'),
			},
		});
		*/


		ScrollTrigger.batch("#smx-page-menu li", {
			onEnter: (elements) => {
				gsap.to(elements, {
					opacity: 1,
					translateY: 0,
					stagger: 0.1,
					pointerEvents: 'all',
				});
			},
			onEnterBack: (elements) => {
				gsap.to(elements, {
					opacity: 1,
					translateY: 0,
					stagger: 0.1,
					pointerEvents: 'all',
				});
			},
			onLeave: (elements) => {
				gsap.to(elements, {
					opacity: 0,
					translateY: "3rem",
					stagger: 0.1,
					pointerEvents: 'none',
				});
				// console.log(elements.length, "elements left");
			},

			onLeaveBack: (elements) => {
				gsap.to(elements, {
					opacity: 0,
					translateY: "3rem",
					stagger: 0.1,
					pointerEvents: 'none',
				});
				// console.log(elements.length, "elements left");
			},

			trigger: "#smx-description",
			start: "top 70%",
			end: "top 0%",
		});

		/*

		const menu_els = document.querySelectorAll("#smx-page-menu li");
		var index = 0;
		var animations = [];
		menu_els.forEach((el) => {
			animations[index] = gsap.to(el, {
				scrollTrigger: {
					trigger: "#smx-description",
					start: "top 70%",
					end: "top 50%",
					scrub: true,
					onEnter: () => setTimeout( function(){ 
						el.classList.add('active');
						console.log(index);
					}, index * 300  ),
				},

				delay: index * 10,
				opacity: 1,
				translateY: 0,


			});

			animations[index].delay(0.5 * index);

			index++;
	
		});


		*/

		gsap.to('#smx-product-image', {
			scrollTrigger: {
				trigger: "#smx-description",
				start: "top 50%",
				end: "top 30%",
				scrub: true,
			},

			opacity: 0,
		});


		gsap.to("#smx-description", {
			scrollTrigger: {
				trigger: "#smx-first-content",
				start: "top 80%",
				end: "top 50%",
				scrub: true,
				// markers: true,
				onEnter: () => document.getElementById('smx-description').classList.add('hide'),
				onLeaveBack: () => document.getElementById('smx-description').classList.remove('hide'),
			},
		});

		const simple_texts = document.querySelectorAll('.simple-text');

		simple_texts.forEach((text) => {

			gsap.to(text, {
				scrollTrigger: {
					trigger: text,
					start: "top 80%",
					end: "top 50%",
					scrub: true,
					// markers: true,
					onEnter: () => text.classList.add('visible'),
					onLeaveBack: () => text.classList.remove('visible'),
				},
			});

		});


		const lines = document.querySelectorAll('.line');

		lines.forEach((line) => {

			gsap.to(line, {
				scrollTrigger: {
					trigger: line,
					start: "top 80%",
					end: "top 50%",
					scrub: true,
					onEnter: () => line.classList.add('visible'),
					onLeaveBack: () => line.classList.remove('visible'),
				},
			});

		});


		const less_important_contents = document.querySelectorAll('.less-important-content');

		less_important_contents.forEach((content) => {

			gsap.to(content, {
				scrollTrigger: {
					trigger: content,
					start: "top 80%",
					end: "top 50%",
					scrub: true,
					onEnter: () => content.classList.add('visible'),
					onLeaveBack: () => content.classList.remove('visible'),
				},
			});

		});






	}




}



export default { initScrollBasedAnimations }